@if (showEachWayButton) {
    <div class="eachway-price-button__container">
        <button
            class="eachway-price-button"
            [class.selected]="isEachWaySelected || isEachWayExtra"
            [disabled]="isEachWayExtra"
            (click)="onEachwayButtonClick($event)">
            {{ messages.common.EachWayAbbr }}
        </button>
        @if (showEachWayText) {
            <span class="eachway-price-terms-text">{{ eachWayTerms }}</span>
        }
    </div>
}
@if (showEachWayInColumn) {
    <div class="eachway-price-terms-column">
        <b>{{ messages.common.EachWayAbbr }}</b
        ><span>{{ eachWayTerms }}</span>
    </div>
}
